/**
 * Is image source
 */
export function isSrc(url) {
  return /^(https?:)?\/\/|data:image/.test(url);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/utils/validate/src.js
// module id = null
// module chunks = 